export const todayDateInputValue = (): string => new Date().toISOString().split('T')[0];

export const toDateInputValue = (iso?: string | null): string =>
  iso ? String(iso).split('T')[0] : todayDateInputValue();
